import React from "react";
import {
    HistoryOutlined,
    WalletOutlined,
    DollarOutlined,
    InfoCircleOutlined,
    CalendarOutlined,
    FileTextOutlined
} from "@ant-design/icons";
import { Col, Row, Tag } from "antd";
import { formatDateTime, formatDateTimeFromNow } from "../../../../utils/functions";
import CommonCard from "../../../global/card";

const EnhancedPaymentHistoryDetails = ({
    paymentDetail,
}) => {
    if (!paymentDetail) return null;

    const getIconForField = (label) => {
        const iconMap = {
            "Amount": <DollarOutlined />,
            "Gateway": <WalletOutlined />,
            "Description": <FileTextOutlined />,
            "Payment At": <CalendarOutlined />,
            "Transaction ID": <InfoCircleOutlined />,
        };
        return iconMap[label] || <InfoCircleOutlined />;
    };

    return (
        <div className="p-6" style={{ backgroundColor: "#f5f7fa" }}>
            <CommonCard
                title={
                    <div className="flex items-center gap-2">
                        <HistoryOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                        <span style={{ fontSize: "16px", fontWeight: 600 }}>Payment Details</span>
                    </div>
                }
            >
                <Row gutter={[24, 0]}>
                    {/* Payment Summary Section */}
                    <Col span={24} className="border-b border-gray-200 py-4">
                        <div className="flex items-center gap-2 mb-4">
                            <DollarOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "16px" }} />
                            <span style={{ fontSize: "15px", fontWeight: 600 }}>Payment Information</span>
                        </div>
                        <Row gutter={[24, 16]}>
                            {[
                                {
                                    label: "Amount",
                                    value: `${paymentDetail.amount} $`,
                                    isTag: true,
                                    tagColor: "success"
                                },
                                {
                                    label: "Gateway",
                                    value: paymentDetail?.paymentGateway,
                                    isTag: true,
                                    tagColor: "blue"
                                },
                                {
                                    label: "Transaction ID",
                                    value: paymentDetail?._id || paymentDetail?.id
                                },
                                {
                                    label: "Payment At",
                                    value: `${formatDateTime(paymentDetail?.createdAt)} (${formatDateTimeFromNow(paymentDetail?.createdAt)})`
                                },
                            ].map((item) => (
                                <Col span={12} key={item.label}>
                                    <div className="flex flex-col">
                                        <span className="text-xs text-gray-500 flex items-center gap-2 mb-1">
                                            <span style={{ color: "var(--primary-color, #1890ff)" }}>
                                                {getIconForField(item.label)}
                                            </span>
                                            {item.label}
                                        </span>
                                        {item.isTag ? (
                                            <Tag color={item.tagColor || "blue"} className="m-0 px-3 py-1 font-medium capitalize w-fit">
                                                {item.value || "—"}
                                            </Tag>
                                        ) : (
                                            <span className="text-sm font-semibold text-gray-900">{item.value || "—"}</span>
                                        )}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>

                    {/* Description Section */}
                    <Col span={24} className="py-4">
                        <div className="flex items-center gap-2 mb-3">
                            <FileTextOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "16px" }} />
                            <span style={{ fontSize: "15px", fontWeight: 600 }}>Description</span>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
                            <p className="text-sm text-gray-700 whitespace-pre-wrap m-0">
                                {paymentDetail?.description || "No description provided."}
                            </p>
                        </div>
                    </Col>
                </Row>
            </CommonCard>
        </div>
    );
};

export default EnhancedPaymentHistoryDetails;
